import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'crm-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ErrorComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
